__webpack_require__.p = "https://caracalui.gamma.eu-west-1.urc.advertising.amazon.dev/";